<template>
  <div class="container">
    <el-container>
      <el-header>
        <div class="title">中国辞书学会</div>
        <div class="user">
          <span>{{ userName.username||'' }}</span>
          <!-- <el-dropdown trigger="click" @command="commandHander"> -->
            <!-- <span class="el-dropdown-link">
              <i class="el-icon-switch-button"  style="margin-right: 15px;color:red;font-size:18px"></i>
            </span> -->
            <el-button type="danger" @click="commandHander('out')"  icon="el-icon-switch-button" circle size="mini" style="margin-left: 15px;"></el-button>
            <!-- <el-dropdown-menu
              slot="dropdown"
              style="width: 120px; text-align: center"
            >
              <el-dropdown-item command="out"> 安全退出 </el-dropdown-item>
            </el-dropdown-menu> -->
          <!-- </el-dropdown> -->
        </div>
      </el-header>
      <el-container class="content">
        <el-aside width="240px" style="background-color: rgb(238, 241, 246)">
          <el-menu
            :default-active="activeMenu"
            class="el-menu-vertical-demo"
            :router="isRouter"
            unique-opened
            @open="handleOpen"
            @close="handleClose"
          >
            <el-menu-item index="/home">
              <i class="el-icon-menu"></i>
              <span slot="title">首页轮播图</span>
            </el-menu-item>
            <!-- <el-menu-item index="/banner">
              <i class="el-icon-location"></i>
              <span>首页轮播图</span>
            </el-menu-item> -->
            <el-menu-item index="/big-event">
              <i class="el-icon-bank-card"></i>
              <span>大事记列表</span>
            </el-menu-item>

            <el-menu-item index="/society-activity">
              <i class="el-icon-document"></i>
              <span slot="title">学会活动</span>
            </el-menu-item>

            <el-submenu index="/dictionary-train">
              <template slot="title">
                <i class="el-icon-picture-outline-round"></i>
                <span>辞书培训班</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/dictionary-train"
                  >辞书培训班</el-menu-item
                >
                <el-menu-item index="/dictionary-train-apply"
                  >培训班报名表</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="/banner-manage">
              <template slot="title">
                <i class="el-icon-c-scale-to-original"></i>
                <span slot="title">辞书世界</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/dictionaries-management"
                  >纸质辞书管理</el-menu-item
                >
                <el-menu-item index="/digital-media">融媒辞书管理</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="/brand-dictionary">
              <i class="el-icon-monitor"></i>
              <span slot="title">品牌辞书</span>
            </el-menu-item>
            <el-submenu index="/dictionary-research">
              <template slot="title">
                <i class="el-icon-coordinate"></i>
                <span slot="title">辞书研究</span>
              </template>
              <el-menu-item-group>
                <el-menu-item :index="resolvePath('/dictionary-research')"
                  >辞书研究</el-menu-item
                >
                <el-menu-item :index="resolvePath('/dictionary-magazine')"
                  >期刊文章列表</el-menu-item
                >
                <!-- <el-menu-item index="/digital-media-pdf">文章pdf上传</el-menu-item> -->
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="/email" v-hasPermi="['function:email:list']">
              <i class="el-icon-postcard" />
              <span slot="title">邮箱列表</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <div class="history_router">
            <tags-view />
          </div>
          <!-- 使用keep-alive 保存活动组件 -->
          <transition name="fade-transform" mode="out-in">
            <keep-alive :include="cachedViews">
              <router-view :key="key" />
            </keep-alive>
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import router from '@/router'
import path from 'path'
import { MessageBox } from 'element-ui'
import { removeToken, delUserInfo, getUserInfo, delPermissionInfo, delUserRoles } from '@/utils/auth.js'
import LoginApi from '@/api/login'
import { mapRequestActions } from '@/utils'
import TagsView from './components/TagsView'
export default {
  components: {
    TagsView
  },
  data () {
    return {
      isRouter: true,
      routePath: '/home',
      userName: getUserInfo() || {},
      errorImg01: 'this.src="' + require('@/assets/images/avatar.jpg') + '"'
    }
  },
  computed: {
    // 点击tab页 高亮layout Item
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    }
  },
  created () {},
  methods: {
    ...mapRequestActions(LoginApi),
    handleOpen (key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    resolvePath (routePath, routeQuery) {
      if (routePath) {
        return routePath
      }
      if (this.basePath) {
        return this.basePath
      }
      if (routeQuery) {
        const query = JSON.parse(routeQuery)
        return { path: path.resolve(this.basePath, routePath), query: query }
      }
      return path.resolve(this.basePath, routePath)
    },
    // 安全退出
    commandHander (e) {
      if (e === 'out') {
        MessageBox.confirm('您确定要退出当前登录用户吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              return this.hanldeLoginOutAction()
                .then((resp) => {
                  if (resp.status) {
                    removeToken()
                    delUserInfo()
                    delPermissionInfo()
                    delUserRoles()
                    router.push('/user/login')
                    this.$message.success('安全退出成功')
                    location.reload()
                  } else if (resp.errorCode === '500') {
                    router.push('/user/login')
                    location.reload()
                    removeToken()
                    delUserInfo()
                    delPermissionInfo()
                    delUserRoles()
                    this.$message.success('安全退出成功')
                  } else {
                    removeToken()
                    delUserInfo()
                    delPermissionInfo()
                    delUserRoles()
                    router.push('/user/login')
                    this.$message.error(resp.errorMsg || '安全退出失败')
                  }
                  done()
                  instance.confirmButtonLoading = false
                })
                .catch(() => {
                  done()
                  instance.confirmButtonLoading = false
                })
            } else {
              done()
            }
          }
        })
      }
    }
  }
}
</script>

<style lang='less' scoped>
.el-header {
  position: fixed;
  width: 100%;
  color: #333;
  text-align: center;
  line-height: 60px;
  border-bottom: none !important;
  z-index: 999;
  background-color: #2c4597;
  // background-image: linear-gradient(45deg, #1278f6, #00b4aa 50%, #1278f6);
  background-image: url('../../assets/images/logo_bg.png');
  background-position: center;
  .title {
    text-align: center;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    padding-left: 20px;
    float: left;
  }
  .user {
    float: right;
    color: #fff;
    font-size: 14px;
    margin-right: 30px;
  }
}

.el-aside {
  background-color: #343a40;
  color: #333;
  text-align: left;
  position: fixed;
  top: 60px;
  height: 100%;
  min-height: 500px;
  z-index: 2;
}
/deep/ .el-menu-item-group__title {
  padding: 0;
}
.el-main {
  padding-left: 241px;
  padding-top: 61px;
  background-color: #fefefe;
  height: 100%;
  .history_router {
    // min-height: 50px;
    // line-height: 50px;
    padding: 4px 0 8px;
    // display: flex;
    // align-items: center;
    // justify-content: start;
    flex-wrap: wrap;
    border-bottom: 1px solid #dcdfe6;
  }
  .el-tag {
    margin: 10px 5px;
  }
}
</style>
